export default __webpack_public_path__ + "src/images/icon_slide_white-cf04f7.png";